import React, { useContext } from "react";
import { LayoutContext, constants } from "./LayoutContext";

const Main = React.memo(props => {
  // const { i18n } = props;
  const layoutContext = useContext(LayoutContext);
  const { theme } = layoutContext;

  // false &&
  //   console.log(
  //     "__debug [Main] 🥰 🥰 🥰 🥰 🥰 🥰 " +
  //       JSON.stringify({ i18n_from_props: i18n })
  //   );

  return (
    <div
      className={theme === constants.THEME_LIGHT ? "theme-light" : "theme-dark"}
      id="main"
    >
      {props.children}
    </div>
  );
});

export { Main };
